import { REQUEST_METHOD } from 'utils/apiClient'
import { APIRoute } from 'routes/api'
import { createApiThunk } from 'utils/thunkWrapper'
import { getConfiguration as fetchConfiguration } from 'api/configuration'
import type { ConfigurationResponse } from 'api/types'

export const forgotPassword = createApiThunk<APIResponse, ForgotPasswordPayload>({
  action: 'authentication/forgotPassword',
  method: REQUEST_METHOD.POST,
  formatUrl: () => APIRoute.POST_RESET_PASSWORD,
  getData: (payload) => payload,
  getSuccessMessage: (payload) => payload.successMessage,
})

export const validateResetToken = createApiThunk<APIResponse, TokenCheckPayload>({
  action: 'authentication/validateResetToken',
  method: REQUEST_METHOD.POST,
  formatUrl: () => APIRoute.POST_VALIDATE_TOKEN,
  getData: (payload) => payload,
})

export const resetPassword = createApiThunk<APIResponse, ResetPasswordPayload>({
  action: 'authentication/resetPassword',
  method: REQUEST_METHOD.POST,
  formatUrl: () => APIRoute.POST_ACTIVATE_ACCOUNT,
  getData: (payload) => payload,
  getSuccessMessage: (payload) => payload.successMessage,
})

// Goes through the generated types: url, method and response shape are checked
// against openapi/openapi.json.
export const getConfiguration = createApiThunk<ConfigurationResponse, void>({
  action: 'authentication/getConfiguration',
  request: fetchConfiguration,
})
